var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckEmailEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 137,
    viewBox: "0 0 160 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M35.1618 109.016C31.0278 106.472 9.72183 93.116 6.54183 67.994C3.04383 41.6 22.7598 22.838 25.6218 20.294C28.8018 17.432 45.9738 1.85 65.6898 5.03C81.2718 7.574 80.6358 19.976 99.0798 27.926C120.386 36.83 133.106 25.7 144.236 34.922C155.684 44.144 156.32 66.722 149.96 81.986C134.696 116.966 72.3678 132.23 35.1618 109.016Z",
    fill: "#29B4D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M74.2761 122.372C103.85 124.28 124.52 109.016 129.608 104.882C133.742 101.702 141.692 93.116 144.872 79.76C151.55 51.776 131.516 18.068 105.44 11.39C91.1301 7.57398 77.7741 12.98 61.5561 19.34C48.8361 24.428 37.7061 28.562 29.7561 38.42C10.9941 61.952 25.3041 99.158 26.8941 102.974C32.6181 107.744 49.1541 120.782 74.2761 122.372Z",
    fill: "#1C6FBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7321 33.65L29.4381 63.224C27.2121 64.814 26.2581 67.676 27.2121 70.22C35.1621 92.798 56.7861 107.744 80.6361 106.79C102.578 105.836 121.976 91.208 129.29 70.22C130.244 67.676 129.29 64.814 127.064 63.224L85.0881 33.65C80.9541 30.788 75.5481 30.788 71.7321 33.65Z",
    fill: "#1D2B87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.93 45.734H32.6182V98.84H122.93V45.734Z",
    fill: "url(#paint0_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2119 68.948C27.2119 80.396 27.2119 91.526 27.2119 102.974C32.2999 107.426 38.3419 111.56 44.7019 114.74C56.1499 108.38 67.2799 101.702 78.7279 95.342C61.5559 86.756 44.3839 77.852 27.2119 68.948Z",
    fill: "url(#paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6821 96.614C90.8121 102.974 101.942 109.016 112.754 115.376C118.796 112.514 124.52 109.016 129.608 104.882C129.608 92.798 129.608 81.032 129.608 68.948C113.072 78.17 96.2181 87.392 79.6821 96.614Z",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5477 84.212L40.8857 113.15C52.0157 119.192 65.0537 122.69 79.0457 122.69C92.4017 122.69 105.122 119.51 115.934 113.786L80.9537 84.212C79.6817 82.622 77.4557 82.622 75.5477 84.212Z",
    fill: "#29B4D7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 77.591,
    y1: 45.8879,
    x2: 77.591,
    y2: 98.9112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2716,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4609,
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7311,
    stopColor: "#E0E1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 71.0581,
    y1: 124.045,
    x2: 43.3625,
    y2: 86.4011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2B87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29B4D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 82.8873,
    y1: 125.673,
    x2: 114.694,
    y2: 89.3426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2B87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29B4D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckEmailEnvelope);
export default __webpack_public_path__ + "static/media/check-email-envelope.bd229075aaf70c8267c3545c0eff45ac.svg";
export { ForwardRef as ReactComponent };